import { money, monthLabel } from "@/lib/format";

export interface MsiCommitments { total: number; by_month: { month: string; amount: number }[] }

export function MsiCommitmentsNote({ c, testId, text }: { c?: MsiCommitments | null; testId: string; text: (total: string) => string }) {
  if (!c || c.total <= 0) return null;
  return (
    <div className="mt-3 rounded-lg bg-[#FBF3DF] px-3 py-2 text-sm text-[#5C4714]" data-testid={testId}>
      <p className="font-semibold">{text(money(c.total))}</p>
      <ul className="mt-1 space-y-0.5 text-xs">
        {c.by_month.map((m) => (
          <li key={m.month} className="flex justify-between gap-3 capitalize" data-testid={`${testId}-${m.month}`}><span>{monthLabel(m.month)}</span><span className="tabular">{money(m.amount)}</span></li>
        ))}
      </ul>
    </div>
  );
}
